import api from './interceptor';

const BASE_URL_V3 = 'api/v3/clinic';

export default {
  // API Version 1
  createDepartment: department => api.post(`${BASE_URL_V3}/department`, department),
  updateDepartment: department => api.put(`${BASE_URL_V3}/department`, department),
  getDepartment: params => api.get(`${BASE_URL_V3}/department`, { params }),
};
